'use client'
import { createGlobalStyle } from 'styled-components'
import localFont from 'next/font/local'
import { SCREEN_SIZE } from '../lib/Media'
import getThemeBackground from '../utils/themeBackground'
import getThemeColors from '../utils/themeColors'
import getThemeFont from '../utils/themeFont'

const harmonia = localFont({
  src: '../public/fonts/harmoniasans_normal_400.woff2',
  variable: '--font-harmonia',
  preload: true,
  fallback: ['system-ui', 'sans-serif'],
})

const schibsted = localFont({
  src: '../public/fonts/SchibstedGrotesk_regular_400.woff2',
  variable: '--font-schibsted',
  preload: true,
  fallback: ['system-ui', 'sans-serif'],
})

const GlobalStyles = createGlobalStyle`
* {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  a {
      text-decoration: none;
      cursor: pointer;
  }

  ul {
    list-style: none;
  }

  svg {
    vertical-align: top;
  }

  button,
  input {
    font-family: inherit;
  }

  input {
    outline: none;
    border: none;
  }

  html {
    font-size: 62.50%;
    --font-harmonia: ${harmonia.style.fontFamily};
    --font-schibsted:${schibsted.style.fontFamily};
    --color-primary:${({ themeName }) => getThemeColors(themeName, 'Primary')};
    --color-secondary:${({ themeName }) =>
      getThemeColors(themeName, 'Secondary')};
  }

  body {
    box-sizing: border-box;
    font-family: ${({ theme }) => getThemeFont(theme)};
    margin: 0;
    background-color: ${({ theme }) => getThemeBackground(theme)};
    min-height: ${({ theme }) => theme === 'Zopnow' && 'calc(100vh - 8rem)'};
    max-width: ${({ theme }) => theme === 'Zopnow' && '150rem'};
    margin: ${({ theme }) => theme === 'Zopnow' && '0 auto'};
    direction: ${({ direction }) => direction || 'rtl'};
  }

  --loader-margin: 0rem;
  ${SCREEN_SIZE.From.Desktop} {
    :root { --loader-margin: 25rem; }
  }
  
  /*  We are globally adding the below two styles of strong and em for the content block pages. 
      If from admin site we get styled static text then those styles should not get override by user style agent. so for that below two css properties are added. */
      
  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }
`

export default GlobalStyles